<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 09:54:49
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-20 15:27:34
-->
<template>
    <div>
        <div class="top">
            <div class="log-box">
                <div @click="changeType(1)" :style="{color:type==1?'#1890FF':''}" class="log">基本设置</div>
                <div @click="changeType(2)" :style="{color:type==2?'#1890FF':''}" class="log">网站信息</div>
                <div @click="changeType(3)" :style="{color:type==3?'#1890FF':''}" class="log">SEO设置</div>
                <div @click="changeType(4)" :style="{color:type==4?'#1890FF':''}" class="log">其他设置</div>
                <div @click="changeType(5)" :style="{color:type==5?'#1890FF':''}" class="log">模板设置</div>
            </div>
        </div>
        <div class="content">
            <el-form :model="ruleForm" :style="{width:type==5?'680px':'580px',height:height}" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <div v-if="type==1">
                    <el-form-item label="站点ID" prop="siteId">
                        <el-input placeholder="10000" v-model="ruleForm.siteId" :disabled="true"></el-input>
                        <div class="tips-text">由系统生成,无法修改</div>
                    </el-form-item>
                    <el-form-item label="网站名称" prop="name">
                        <el-input v-model="ruleForm.name" placeholder="请输入网站名称"></el-input>
                        <div class="tips-text">政府网站的规范名称，将同步设置为SiteName</div>
                    </el-form-item>
                    <el-form-item label="网站域名" prop="domain">
                        <el-input disabled placeholder="请输入网站访问域名" v-model="ruleForm.domain">
                            <template slot="prepend">Http://</template>
                        </el-input>
                        <div class="tips-text">政府网站的英文域名，将同步设置为SiteDomain</div>
                    </el-form-item>
                    <el-form-item  label="网站标识码">
                        <el-input  @input="codeFn" placeholder="请输入网站标识码" v-model="ruleForm.siteIdCode" maxlength="10">
                        </el-input>
                        <div class="tips-text">政府网站合法身份的标识，通常为十位纯数字，将同步设置为SiteIDCode</div>
                        <div v-if="isErr"  class="item-error">{{errTxt}}</div>
                    </el-form-item>
                    <el-form-item label="站点描述" prop="remark">
                        <el-input placeholder="请输入站点描述" v-model="ruleForm.remark" type="textarea" :rows="4">
                        </el-input>
                    </el-form-item>
                </div>
                <div v-if="type==2">
                    <el-form-item label="网站logo" prop="siteLogo">
                        <el-upload  class="avatar-uploader" :show-file-list="false" :before-upload="beforeLogoUpload" action="#" list-type="picture-card"  :limit="1" :multiple="false">
                            <!-- <img v-if="logoImg" :src="imgIp + logoImg" class="el-upload-list__item-thumbnail">-->
                            <div class="box-img el-upload-list__item-thumbnail"   style="width: 100%; height: 100%;" v-if="logoImg">
                                <img
                                    style="width: 100%; height: 100%"
                                    :src="imgIp + logoImg"
                                    alt="avatar"
                                />
                                <i @click.stop="deletImg" class="el-icon-close img-box-icon"></i>
                            </div>
                            <img v-if="!logoImg" src="@/assets/images/upload-img.png" class="el-upload-list__item-thumbnail">
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="地址栏图标" prop="siteAddressImg">
                         <el-upload :show-file-list="false" :before-upload="beforePathUpload" action="#" list-type="picture-card"  :limit="1" :multiple="false">
                             <div class="box-img el-upload-list__item-thumbnail"   style="width: 100%; height: 100%;" v-if="pathImg">
                                <img
                                    style="width: 100%; height: 100%"
                                    :src="imgIp + pathImg"
                                    alt="avatar"
                                />
                                <i @click.stop="deletPathImg" class="el-icon-close img-box-icon"></i>
                            </div>
                            <img v-if="!pathImg" src="@/assets/images/upload-img.png" class="el-upload-list__item-thumbnail">
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="主办单位" prop="siteDirectorUnit">
                        <el-input v-model="ruleForm.siteDirectorUnit" placeholder="请输入网站主管单位"></el-input>
                    </el-form-item>
                    <el-form-item label="承办单位">
                        <el-input v-model="ruleForm.siteSponsor" placeholder="请输入网站主办单位"></el-input>
                    </el-form-item>
                    <el-form-item label="维护单位" prop="siteMaintainUnit">
                        <el-input v-model="ruleForm.siteMaintainUnit" placeholder="请输入网站维护单位"></el-input>
                    </el-form-item>
                    <el-form-item label="网站备案内容" prop="siteRecordNote">
                        <el-input v-model="ruleForm.siteRecordNote" placeholder="请输入网站备案内容"></el-input>
                        <div class="tips-text">ICP备案号,格式如：蜀ICP备 12345678号</div>
                    </el-form-item>
                      <el-form-item label="网站备案跳转" prop="siteRecordUrl">
                        <el-input v-model="ruleForm.siteRecordUrl" placeholder="请输入网站备案跳转"></el-input>
                       
                    </el-form-item>
                    <el-form-item label="公网安备内容" prop="sitePoliceNote">
                        <el-input v-model="ruleForm.sitePoliceNote" placeholder="请输入网站备案内容"></el-input>
                        <div class="tips-text">公安机关联网备案号,格式如：川公网安备 12345678号</div>
                    </el-form-item>
                     <el-form-item label="公网安备跳转" prop="sitePoliceUrl">
                        <el-input v-model="ruleForm.sitePoliceUrl" placeholder="请输入公网安备跳转"></el-input>
                       
                    </el-form-item>
                </div>
                <div v-if="type==3">
                    <el-form-item label="SEO标题" prop="siteSeoTitle">
                        <el-input v-model="ruleForm.siteSeoTitle" placeholder="请输入SEO标题"></el-input>
                    </el-form-item>
                    <el-form-item label="SEO关键字" prop="siteSeoKeyword">
                        <el-input placeholder="请输入SEO关键字" v-model="ruleForm.siteSeoKeyword" type="text">
                        </el-input>
                        <div class="tips-text">可填入多个关键字,以英文","隔开</div>
                    </el-form-item>
                    <el-form-item label="SEO描述" prop="siteSeoNote">
                        <el-input placeholder="请输入SEO描述" v-model="ruleForm.siteSeoNote" type="textarea" :rows="4">
                        </el-input>
                    </el-form-item>
                </div>
                <div v-if="type==4">
                    <el-form-item  label="一键置灰" prop="siteIsGrey">
                        <div class="status"><el-radio v-model="ruleForm.siteIsGrey" label="true">启用</el-radio>
                        <el-radio v-model="ruleForm.siteIsGrey" label="false">停用</el-radio></div>
                    </el-form-item>
                    <el-form-item label="置灰时间" prop="greyTime">
                        <div class="block">
                            <el-date-picker
                            style="width:436px"
                            v-model="ruleForm.greyTime"
                            type="datetimerange"
                            range-separator="至"
                            @input="changeTime"
                            start-placeholder="开始日期 时间"
                            end-placeholder="结束日期 时间">
                            </el-date-picker>
                        </div>
                    </el-form-item>
                    <el-form-item  label="外链提示" prop="siteOutsideChainHint">
                        <div class="status"><el-radio v-model="ruleForm.siteOutsideChainHint" label="true">启用</el-radio>
                        <el-radio v-model="ruleForm.siteOutsideChainHint" label="false">停用</el-radio></div>
                        <div class="tips-text">启用后,在网站跳转其他链接时,将弹出温馨提示</div>
                    </el-form-item>
                    <el-form-item label="外链白名单" prop="siteOutsideChainWhiteList">
                        <el-input placeholder="请输入外链白名单" v-model="ruleForm.siteOutsideChainWhiteList" type="textarea" :rows="4">
                        </el-input>
                        <div class="tips-text">回车换行、一行输入一个外链地址,若取消白名单,删除即可</div>
                    </el-form-item>
                </div>
                <div v-if="type==5">
                    <el-form-item label="首页模板" prop="name">
                        <div style="display:flex">
                            <el-input  disabled placeholder="首页的模板文件" v-model="ruleForm.siteIndexTemplate">
                             <div class="change-model" slot="append" @click="chooseTemplate">选择模板</div>
                            </el-input>
                            <div @click="deleteModel" class="icon-box"><i class="el-icon-delete"></i></div>
                        </div>
                    </el-form-item>
                    
                </div>
            </el-form>
             <div class="form-bottom">
                        <el-button :loading="loading"  v-if="codeData.indexOf('207') != -1" class="btn"   @click="submitForm('ruleForm')" size="medium" type="primary">保存</el-button>
                    </div>
        </div>
        <!-- 选择模板 -->
        <div class="choose_template">
            <el-dialog title="选择模板" width="700px" :visible.sync="templateIsShow">
                <div class="lod-tips">
                    <span>I</span>
                    模板只能选择.csshtml后缀的文件，点击文件夹图标可进入下级目录
                </div>
                <div class="choose-path">
                     <span @click="returnParent(templateList.directoryPath)"  class="icon-arrow-back back-box"></span>  /{{templateList.directoryPath}}
                </div>
                <div class="template-list">
                    <div class="title item">名称</div>
                    <div class="list-box">
                          <div class="item" v-for="(item,index) in templateList.templateDirectoryAndFileResponse" :key="index" @click="getTemplates(item.isDir,item.name,item.allPath,2)">{{item.name}}</div>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {addSite,getSiteDetail,getTemplateList} from './site_settings.js';
import { message } from 'ant-design-vue';
import {uploadImg} from '@/utils/common.js'

export default {
    data() {
        return {
            type:1,
            loading:false,
            ruleForm:{
                Id:'10000',
                name:'',
                siteIsGrey:'true',
                siteOutsideChainHint:'true',
                siteIdCode:'',
            },
            rules: {
                siteIdCode:[
                    { type: 'number', message: '请输入十位纯数字', trigger: 'blur' },
                    { min: 10, max: 10, message: "请输入十位纯数字", trigger: "blur" },
                ]
            },
            templateIsShow:false,
            templateList:{},
            logoImg:'',
            pathImg:'',
            codeData:[],
            errTxt:'',
            isErr:false,
            height:0,
        };
    },
    components: {},
    mounted() {
        this.getSite()
        this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
         this.height = `${document.documentElement.clientHeight - 320}px`;
         window.onresize = () => {
                            return (() => {
                                this.height = `${document.documentElement.clientHeight - 320}px`;
                            })();
                        };
    },
    methods: {
        deletImg(){
            this.logoImg = '';
        },
        deletPathImg(){
            this.pathImg = '';
        },
        deleteModel(){
            this.ruleForm.siteIndexTemplate = '';
            this.ruleForm = JSON.parse(JSON.stringify(this.ruleForm))
        },
        codeFn(e){
            if(!(/^[0-9]+$/.test(e))){
                this.isErr = true;
                this.errTxt = '请输入十位纯数字';
            }
            if(e.length != 10){
                this.isErr = true;
                this.errTxt = '请输入十位纯数字';
            }
            if(/^[0-9]+$/.test(e) && e.length == 10){
                 this.isErr = false;
            }
        },
        changeTime(){
            this.ruleForm = JSON.parse(JSON.stringify(this.ruleForm))
        },
         returnParent(directoryPath){
            let path = directoryPath.substring(0,directoryPath.lastIndexOf('/',directoryPath.lastIndexOf('/')-1)+1)
            if(path){
                this.getTemplates(true,'',path,2)
            }
        },
        // 图片上传
        beforeLogoUpload(file) {
            if(['image/jpeg','image/jpg','image/png','image/jpg'].indexOf(file.type) == -1){
                     message.error('image/jpeg/png/jpg 格式!');
                     return;
            }
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                message.error('大小不能超过2m!');
                return;
            }
            uploadImg(file,'site_setting').then((res)=>{
                   this.logoImg = res.path;
            })
            return false;
        },
         beforePathUpload(file) {
            if(['image/jpeg','image/jpg','image/png','image/jpg'].indexOf(file.type) == -1){
                     message.error('image/jpeg/png/jpg 格式!');
                     return;
            }
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                message.error('大小不能超过2m!');
                return;
            }
            uploadImg(file,'site_setting').then((res)=>{
                   this.pathImg = res.path;
            })
            return false;
        },
        changeType(type){
            this.$nextTick(()=>{
                this.type = type
            })
        },
        //获取站点详情
        getSite(){
            const _this = this
            getSiteDetail({id:sessionStorage.getItem('siteId')}).then(res=>{
                if(res.code==0){
                    console.log(res)
                    _this.ruleForm = res.data
                    _this.logoImg = res.data.siteLogo;
                    _this.pathImg = res.data.siteAddressImg;
                    _this.ruleForm.siteIsGrey = _this.ruleForm.siteIsGrey?'true':'false'
                    _this.ruleForm.siteOutsideChainHint = _this.ruleForm.siteOutsideChainHint?'true':'false'
                    _this.ruleForm.greyTime = [new Date(_this.ruleForm.siteGreyStartTime),new Date(_this.ruleForm.siteGreyEndTime)]
                }
            })
        },
        //新增、修改站点详情
        submitForm(){
            const _this = this
            this.loading = true;
            let errorData = document.getElementsByClassName("item-error");
            if (errorData.length > 0) {
                message.error("请正确填写数据");
                this.loading = false;
                return;
            }
            if(_this.ruleForm.greyTime && _this.ruleForm.greyTime.length!=0){
                _this.ruleForm.siteGreyStartTime =_this.farmatDate(new Date( _this.ruleForm.greyTime[0].toString()).getTime(),'-')
                _this.ruleForm.siteGreyEndTime =_this.farmatDate(new Date( _this.ruleForm.greyTime[1].toString()).getTime(),'-')
            }
            _this.ruleForm.siteLogo = this.logoImg;
            _this.ruleForm.siteAddressImg = this.pathImg;
            addSite(_this.ruleForm).then(res=>{
                if(res.code==0){
                    message.success(res.msg);
                    this.getSite()
                }
                this.loading = false;
            })
        },
        farmatDate(date,cut) {
            var date = new Date(date)
            var YY = date.getFullYear() + cut ;
            var MM = (date.getMonth() + 1 < 10? "0" + (date.getMonth() + 1): date.getMonth() + 1) + cut;
            var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            var hh =(date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
            var mm =(date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +":";
            var ss = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
            return YY + MM + DD + " " + hh + mm + ss;
        },
        // 选择模板
        chooseTemplate(type){
            const _this = this
            _this.templateIsShow = true
            _this.getTemplates(true)
        },
        getTemplates(isDir,fileName='',path='',type=1){
            const _this = this
            if(isDir){
                let reqData = {
                    fileName:fileName,
                    path: path,
                    siteId: sessionStorage.getItem('siteId'),
                    type: type?type:1,
                    isHtml:true,
                }
                getTemplateList(reqData).then(res=>{
                    if(res.code == 0){
                        _this.templateList = res.data
                    }
                })
            }else{
                let allPath = path.substring(path.indexOf("/")+1, path.length)
                _this.ruleForm.siteIndexTemplate = allPath
                _this.templateIsShow = false
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .top {
        padding: 24px;
        .log-box {
            border-bottom: solid 1px #dcdfe6;
            display: flex;
            color: #000;
            .log {
                padding: 10px 20px;
                border-top: solid 1px #dcdfe6;
                border-left: solid 1px #dcdfe6;
                cursor: pointer;
            }
            .log:last-child {
                border-right: solid 1px #dcdfe6;
                border-top-right-radius: 10px;
            }
            .log:first-child {
                border-top-left-radius: 10px;
            }
        }
    }
    .content{
        padding-left: 24px;
        .demo-ruleForm{
            width: 580px;
            margin-top: 30px;
            padding-left: 24px;
            overflow-y: auto;
            padding-right: 20px;
        }
        .tips-text{
            font-size: 12px;
            // height: 20px;
            line-height: 26px;
            color: #9093a6;
        }
        /deep/ .el-form-item__label {
            text-align: left;
            width: 100px !important;
        }
        /deep/ .el-form-item__content{
            margin-left: 100px !important;
        }
        /deep/ .el-upload--picture-card{
            width: 80px;
            height: 80px;
            line-height: 80px;
            border: none;
            img{
                width: 80px;
                height: 80px;
            }
        }
        /deep/.el-upload-list--picture-card .el-upload-list__item{
            width: 80px;
            height: 80px;
            line-height: 80px;
        }
        .status{
            border:solid 1px #dcdfe6;
            border-radius: 4px;
            padding-left: 10px;
        }
    }
    .choose_template{
        /deep/.el-dialog__title{
            font-size: 18px;
            font-weight: bold;
        }
        /deep/ .el-dialog__body{
            padding-top:10px;
        }
        /deep/ .el-dialog__close{
            font-weight: 600;
        }
        /deep/.el-dialog{
            width: 36%;
        }
        .lod-tips{
            background: #f7f7f7;
            font-size: 12px;
            color: #928f8f;
            line-height: 36px;
            padding: 0 10px;
            border-radius: 4px;
        }
        .choose-path{
            line-height: 50px;
            padding: 0 10px;
            border-radius: 4px;
            border: solid 1px #dcdfe6;
            margin-top:20px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
        }
        .template-list{
            border: solid 1px #dcdfe6;
            border-radius: 4px;
            margin-top:20px;
            .list-box{
                height: 450px;
                overflow-y: auto;
            }
            .title{
                background: #f7f7f7;
            }
            .item{
                font-weight: bold;
                line-height: 52px;
                box-sizing: border-box;
                border-bottom: solid 1px #dcdfe6;
                padding: 0 10px;
                cursor: pointer;
                &:last-child{
                    border:none
                }
            }
        }
        
    }
    .back-box{
  margin-right: 10px;
  cursor: pointer;
}
/deep/ .icon-arrow-back:before{
  font-size: 20px;
}
.btn{
    display: flex;
    justify-content: center;
    align-items: center;
}
.item-error {
  height: 20px;
  color: red;
}
.change-model{
    cursor: pointer;
}
.icon-box{
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.box-img{
  position: relative;
  .img-box-icon{
    position: absolute;
    top: 4px;
    right: 0px;
    font-size: 16px;
    font-weight: bold;
    color: #000;
  }
}
.el-button--primary {
  background: #176de6;
}
.form-bottom{
    margin-left: 124px;
    margin-top: 20px;
}
</style>